import DeleteAccount from 'modules/terms/DeleteAccount'
import React from 'react'

export default function DeleteAccountScreen() {
  return (
    <DeleteAccount />
  )
}
